import { Box, Button, Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerFooter, Flex, Heading, IconButton, Link, useDisclosure } from '@chakra-ui/react';
import { HiXMark } from 'react-icons/hi2';
import { IoLogOutOutline } from 'react-icons/io5';
import { PiMapPinAreaBold, PiSignIn } from 'react-icons/pi';
import { useDispatch } from 'react-redux';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { urlNavigate } from '../../../helper/utils/navigation';
import { doHandleState } from '../../../redux/onlineSales/onlineSales.actions';
import ModalLogIn from './ModalLogIn';

export default function DrawerMenu({ isOpen, onClose, menus = [] }) {
    const navigate = useNavigate();
    const dispacth = useDispatch();
    const isVerifiedWaiver = (localStorage.getItem('isVerifiedWaiver') || 'false') === 'true';

    const { isOpen: isOpenLogIn, onOpen: onOpenLogIn, onClose: onCloseLogIn } = useDisclosure();

    return (
        <>
            <Drawer isOpen={isOpen} placement='right' onClose={onClose}>
                <DrawerContent py={7} boxShadow='0 10px 20px 1000vw rgba(0, 0, 0, 0.5)' borderLeft='1px' borderColor='gray.300'>
                    <DrawerCloseButton />
                    <DrawerBody>
                        <Box>
                            <Flex w='full' alignItems='center' justifyContent='space-between'>
                                <Heading fontSize='2xl' fontWeight={600}>
                                    Explore <br />
                                    The Fun
                                </Heading>
                                <IconButton icon={<HiXMark />} variant='solid' onClick={onClose} />
                            </Flex>
                        </Box>
                        <Box mt={8}>
                            <Flex w='full' h='auto' gap={3} flexDirection='column'>
                                <Link
                                    as={RouterLink}
                                    to={`${urlNavigate('online-sales', 'home')}`}
                                    textTransform='capitalize'
                                    color='gray.400'
                                    fontWeight={400}
                                    transition='all 0.35s ease-in-out'
                                    _hover={{ color: 'black' }}
                                    onClick={() => {
                                        onClose();
                                        localStorage.setItem('product', '{}');
                                    }}>
                                    Home
                                </Link>
                                {menus?.map((product, index) => {
                                    const { title, cta } = product;

                                    return (
                                        <Link
                                            key={`${cta || ''}-${title || ''}-${index}`}
                                            as={RouterLink}
                                            to={`${urlNavigate(cta)}`}
                                            textTransform='capitalize'
                                            color='gray.400'
                                            fontWeight={400}
                                            transition='all 0.35s ease-in-out'
                                            _hover={{ color: 'black' }}
                                            onClick={() => {
                                                onClose();
                                                localStorage.setItem('product', JSON.stringify(product));
                                            }}>
                                            {title}
                                        </Link>
                                    );
                                })}
                            </Flex>
                        </Box>
                    </DrawerBody>
                    <DrawerFooter flexDirection='column' gap={1} py={0}>
                        {isVerifiedWaiver ? (
                            <Button
                                w='full'
                                mx={2}
                                fontSize='15px'
                                fontWeight={600}
                                colorScheme='red'
                                py={6}
                                px={7}
                                leftIcon={<IoLogOutOutline />}
                                onClick={() => {
                                    localStorage.setItem('isVerifiedWaiver', false);
                                    localStorage.setItem('waiver', '{}');
                                    localStorage.setItem('email', '');

                                    window.location.reload();
                                }}>
                                Logout
                            </Button>
                        ) : (
                            <Button
                                w='full'
                                fontSize='15px'
                                fontWeight={600}
                                colorScheme='primary'
                                py={6}
                                variant='solid'
                                leftIcon={<PiSignIn />}
                                onClick={() => {
                                    onOpenLogIn();
                                    onClose();
                                }}>
                                Login
                            </Button>
                        )}

                        <Button
                            w='full'
                            fontSize='15px'
                            fontWeight={600}
                            colorScheme='red'
                            py={6}
                            variant='outline'
                            leftIcon={<PiMapPinAreaBold />}
                            onClick={() => {
                                dispacth(doHandleState('cart', []));
                                navigate('/');
                            }}>
                            Change Location
                        </Button>
                    </DrawerFooter>
                </DrawerContent>
            </Drawer>
            <ModalLogIn isOpen={isOpenLogIn} onClose={onCloseLogIn} />
        </>
    );
}
